import React, { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import DateTimeText from "../../../../../components/DateTimeText";

const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
	},
});

function LongTextWrapper({ text }) {
	return <div style={{ width: "100%", whiteSpace: "break-spaces" }}>{text}</div>;
}

const MySQLSlowQueriesLogs = ({ data }) => {
	const dataWithId = useMemo(() => {
		return data.map((item, index) => ({ ...item, id: index })).reverse();
	}, [data]);

	return (
		<DataGrid
			autoHeight={false}
			style={{ background: "white" }}
			rows={dataWithId}
			rowHeight={100}
			density="compact"
			autoPageSize={true}
			disableColumnFilter={true}
			disableColumnMenu={true}
			disableColumnSelector={true}
			disableDensitySelector={true}
			disableSelectionOnClick={true}
			columns={[
				{
					field: "message",
					headerName: "Message",
					flex: 1,
					sortable: false,
					headerAlign: "left",
					align: "left",
					renderCell: ({ row }) => (
						<CustomWidthTooltip title={row.message}>
							<div>
								<LongTextWrapper text={row.message.length > 150 ? row.message.substr(0, 150) : row.message} />
							</div>
						</CustomWidthTooltip>
					),
				},
				{
					field: "timestamp",
					headerName: "Timestamp",
					renderCell: ({ row }) => <DateTimeText dateTime={row.timestamp} />,
					width: 160,
					sortable: false,
					headerAlign: "center",
					align: "center",
				},
			]}
			pageSize={10}
			rowsPerPageOptions={[10]}
		></DataGrid>
	);
};
export default MySQLSlowQueriesLogs;
